<template>
    <div>
        <v-card>
            <v-card-title>
                Live Rates Shipping Options
                <v-spacer></v-spacer>
                <v-btn v-if="!isNew && integrationId" color="success" small @click="onNewGroup">Add New Shipping Option</v-btn>
                <v-btn
                    v-if="integrationId && groupsSelection.length == 0"
                    color="primary"
                    small
                    class="ml-1"
                    @click="onCreateDefault">
                    Create Default Shipping Options
                </v-btn>
                &nbsp;&nbsp;
                <v-btn v-if="integrationId" color="secondary" small @click="onDisplayLiveRateCarrierGroups">{{ shareCarrierGroupBtnTxt }}</v-btn>
            </v-card-title>
            <v-card-text>
                <v-overlay :value="isLoading">
                    <v-progress-circular
                        indeterminate
                        size="64"
                    ></v-progress-circular>
                </v-overlay>

                <v-form
                    v-if="integrationId"
                    ref="form"
                    v-model="valid"
                    @submit="onSubmitCarrierGroup">
                    <v-container fluid>
                        <v-row>
                            <v-col md="12">
                                <!-- TABLE REPLACES DROPDOWN -->
                                <div v-if="groupsSelection.length > 0 && !isNew && !(option && form)">
                                    <CarrierGroupsTable
                                        :integrationId="integrationId"
                                        :groups="groups"
                                        @edit="selectGroup"
                                        @delete="onDeleteGroup"
                                        @drag-start="dragStart"
                                        @drop="drop"
                                    />
                                </div>
                            </v-col>
                        </v-row>

                        <template v-if="isNew || (option && form)">
                            <v-row>
                                <v-col cols="12">
                                    <div class="d-flex justify-start mb-2 align-items-center justify-content-between">
                                        <v-btn small color="grey" @click="backToList">
                                            <v-icon left>mdi-arrow-left</v-icon>
                                            Back
                                        </v-btn>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col md="4">
                                    <v-text-field
                                        v-model="form.name"
                                        :error-messages="nameErrors"
                                        :counter="100"
                                        label="Shipping Option Label"
                                        required
                                        @input="$v.form.name.$touch()"
                                        @blur="$v.form.name.$touch()">
                                    </v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col md="6">
                                    <v-row>
                                        <v-col>
                                            <v-textarea
                                                v-model="form.description"
                                                label="Description">
                                            </v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-col>

                                <v-col md="6">

                                    <v-row color="gray">
                                        <v-col>
                                            <v-text-field
                                                v-model="form.group_min_weight"
                                                label="Shipping option minimum weight (KG)"
                                                :error-messages="groupMinWeightErrors"
                                                @keypress="isNumber($event)"
                                                @input="$v.form.group_min_weight.$touch()">
                                            </v-text-field>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon v-bind="attrs" v-on="on" class="ml-2">mdi-information</v-icon>
                                                </template>
                                                <span>If any package is over or under this limit, this shipping option will not show.</span>
                                            </v-tooltip>
                                        </v-col>
                                        <v-col>
                                            <v-text-field
                                                v-model="form.group_max_weight"
                                                :error-messages="groupMaxWeightErrors"
                                                @keypress="isNumber($event)"
                                                label="Shipping option maximum weight (KG)"
                                                @input="$v.form.group_max_weight.$touch()">
                                            </v-text-field>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon v-bind="attrs" v-on="on" class="ml-2">mdi-information</v-icon>
                                                </template>
                                                <span>If any package is over or under this limit, this shipping option will not show.</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col>
                                            <v-alert
                                                :value="isShowInfo"
                                                outlined
                                                type="info"
                                                border="left"
                                                transition="scale-transition">
                                                <p> 7 HydraulicLift is a Hydraulic Tailgate required? </p>
                                                <p> 8 CraneTruck is Crane Truck required? </p>
                                                <p> 13 Residential is this a residential delivery? </p>
                                                <p> 14 AuthorisedToLeave is the carrier authorised to leave? </p>
                                                <p> 36 HandUnload does the delivery require a hand unload?</p>
                                            </v-alert>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col>
                                            <v-text-field
                                                v-model="form.question_ids"
                                                :error-messages="questionIdsErrors"
                                                label="Question Ids (Comma delimited)"
                                                @input="$v.form.question_ids.$touch()"
                                                @blur="$v.form.question_ids.$touch()">
                                            </v-text-field>
                                        </v-col>
                                        <v-col class="d-flex align-items-center">
                                            <v-btn
                                                icon
                                                color="info"
                                                @click="isShowInfo = !isShowInfo">
                                                <v-icon dark>
                                                    mdi-information
                                                </v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <hr/>
                            <v-row>
                                <v-col>
                                    <v-row>
                                        <v-col md="4">
                                            <v-select
                                                v-model="form.margin_types"
                                                :items="marginTypes"
                                                label="Margin Types">
                                            </v-select>
                                        </v-col>
                                    </v-row>


                                    <v-row v-if="form.margin_types == 'AUD'">
                                        <v-col md="4">
                                            <v-text-field
                                                v-model="form.value"
                                                type="number"
                                                :error-messages="amountErrors"
                                                label="Amount (AUD)"
                                                required
                                                @input="$v.form.value.$touch()"
                                                @blur="$v.form.value.$touch()">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row v-else-if="form.margin_types == '%'">
                                        <v-col md="4">
                                            <v-text-field
                                                v-model="form.value"
                                                type="number"
                                                :error-messages="amountErrors"
                                                label="Percentage (%)"
                                                required
                                                @input="$v.form.value.$touch()"
                                                @blur="$v.form.value.$touch()">
                                            </v-text-field>
                                        </v-col>
                                        <v-col>
                                            <v-radio-group
                                                :error-messages="roundingErrors"
                                                v-model="form.is_rounding"
                                                required
                                                @input="$v.form.is_rounding.$touch()"
                                                @blur="$v.form.is_rounding.$touch()">
                                                <v-radio
                                                    label="No Rounding"
                                                    value="0"
                                                ></v-radio>
                                                <v-radio
                                                    label="Rounding Up"
                                                    value="up"
                                                ></v-radio>
                                                <v-radio
                                                    label="Rounding Down"
                                                    value="down"
                                                ></v-radio>
                                            </v-radio-group>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col md="4">
                                            <v-text-field
                                                v-model="form.group_minimum_shipping_cost"
                                                type="number"
                                                :error-messages="minimumShippingCostErrors"
                                                label="Minimum Shipping Cost"
                                                @input="$v.form.group_minimum_shipping_cost.$touch()"
                                                @blur="$v.form.group_minimum_shipping_cost.$touch()">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col md="4">
                                            <v-switch
                                                v-model="form.is_ungroup_carrier"
                                                label="">
                                                <template v-slot:label>
                                                    <span>Return All Carriers Ungrouped</span>
                                                </template>
                                            </v-switch>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col class="d-flex align-center">
                                    <v-spacer></v-spacer>
                                    <v-switch v-model="form.enabled" label="Enabled" class="mr-4"></v-switch>
                                    <v-btn small v-if="form && form.id" type="button" color="red" dark @click="onDelete">Delete</v-btn>
                                    <v-btn small v-else type="button" @click="() => ( isNew = false  )">Cancel</v-btn>
                                    <v-btn class="ml-1" small type="submit" color="primary">Save</v-btn>
                                </v-col>
                            </v-row>
                        </template>
                    </v-container>
                </v-form>

                <template v-if="form.id">
                    <v-divider></v-divider>
                    <CarrierGroupServices :carrierGroupId="form.id" :integrationId="integrationId" />
                </template>

            </v-card-text>
        </v-card>
        <Modal
            ref="modal"
            color="error"
            okText="delete" />

    </div>
</template>

<script>
import { EventBus } from '../../../../event-bus.js'
import { validationMixin } from 'vuelidate'
import { required, numeric } from 'vuelidate/lib/validators'
import CarrierGroupServices from './CarrierGroupServices'
import CarrierGroupsTable from './CarrierGroupsTable.vue'
import { dragStart, drop, selectGroup, onDeleteGroup } from './carrierGroupsTableLogic.js'
import { mapGetters } from "vuex"
import Modal from '../../../Modal'

export default {
    props: {
        id: { type: Number, default: null },
    },
    components: {
        CarrierGroupServices,
        CarrierGroupsTable,
        Modal
    },
    mixins: [validationMixin],
    validations: {
        form: {
            value: { required, numeric },
            is_rounding: { required },
            name: { required },
            group_min_weight: { numeric },
            group_max_weight: { numeric },
            question_ids: { numeric },
            group_minimum_shipping_cost: {numeric},
        },
    },
    computed: {

        ...mapGetters('LRSettingsState', {
            defaultSettings: 'getDefaultSettings'
        }),

        groupsSelection() {
            // initial choice
            let groups = [];

            if (this.groups && this.groups.length > 0) {
                this.groups.forEach(group => {
                    let option = {
                        text: group.name,
                        value: group.id
                    }
                    groups.push(option)
                })
            }

            return groups
        },


        integrationId() {
            return this.id
        },

        nameErrors() {
            const errors = []
            if (!this.$v.form.name.$dirty) return errors
            !this.$v.form.name.required && errors.push('Name is required.')
            return errors
        },
        questionIdsErrors() {
            const errors = []
            if (!this.$v.form.question_ids.$dirty) return errors
            return errors
        },
        groupMinWeightErrors() {
            const errors = []
            if (!this.$v.form.group_min_weight.$dirty) return errors
            let minWeight = this.form.group_min_weight?.toString()
            if (this.form.group_min_weight && minWeight.includes('.') && minWeight.split('.')[1].length > 2) errors.push('Up to 2 Decimal places only.')
            this.form.group_min_weight && parseFloat(this.form.group_min_weight) >= parseFloat(this.form.group_max_weight) && errors.push('Group min must be lesser than max weight')
            return errors
        },
        groupMaxWeightErrors() {
            const errors = []
            if (!this.$v.form.group_max_weight.$dirty) return errors
            let maxWeight = this.form.group_max_weight?.toString()
            if (this.form.group_max_weight && maxWeight.includes('.') && maxWeight.split('.')[1].length > 2) errors.push('Up to 2 Decimal places only.')
            return errors
        },

        amountErrors() {
            const errors = []
            if (!this.$v.form.value.$dirty) return errors


            let type = this.form.margin_types == 'AUD' ? 'Amount' : 'Percentage';

            !this.$v.form.value.required && errors.push( type + ' is required.')
            return errors
        },

        roundingErrors() {
            const errors = []
            if (!this.$v.form.is_rounding.$dirty) return errors
            !this.$v.form.is_rounding.required && errors.push('Rounding is required.')
            return errors
        },

        minimumShippingCostErrors() {
            const errors = [];
            if (!this.$v.form.group_minimum_shipping_cost.$dirty) return errors;
            if (!this.$v.form.group_minimum_shipping_cost.numeric) {
                errors.push('Minimum Shipping Cost must be a valid number.');
            }

            return errors;
        },

    },

    watch: {
        option(to, from) {
            if (to && to != from) {
                let group = this.groups.find(group => group.id == to)
                this.form = group
            }
        },

    },

    data() {
        return {
            option: null,
            valid: false,
            form: {
                name: "",
                description: "",
                group_min_weight: null,
                group_max_weight: null,
                integration_id: null,
                slug: "",
                question_ids: null,
                order: 0,
                margin_types: "n",
                value: 0,
                id: null,
                is_ungroup_carrier: false,
                group_minimum_shipping_cost: null,

            },
            marginTypes: [
                { text: 'Percentage (%)', value: '%' },
                { text: 'Fixed ($)', value: 'AUD' },
                { text: 'None', value: 'n' },
            ],
            integration: null,

            groups: [],
            isNew: false,
            isLoading: false,
            isShowInfo: false,
            shareCarrierGroupBtnTxt: "Share shipping options",

            // Drag-and-drop state
            draggedItemIndex: null,
            isSorting: false,
            isSaving: false,
        }
    },

    mounted() {
        this.fetchCarrierGroups()
    },

    methods: {
        backToList() {
            this.reset();
            this.option = null;
        },
        selectGroup(group) {
            selectGroup(this, group);
        },
        onDeleteGroup(group) {
            onDeleteGroup(this, group);
        },
        isNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {

                evt.preventDefault();
            } else {
                return true;
            }
        },
        dragStart(index) {
            dragStart(this, index);
        },
        drop(index) {
            drop(this, index);
        },

        onChooseIntegration(to) {
            console.log('choose integration', to)
            // this.$store.dispatch('setActiveIntegration', to)
            this.integration = to;
        },

        reset() {
            this.valid = false
            this.isNew = false
            this.form = {
                name: "",
                description: "",
                group_min_weight: null,
                group_max_weight: null,
                integration_id: null,
                slug: "",
                question_ids: null,
                order: 0,
                margin_types: "n",
                value: 0,
                id: null,
                is_ungroup_carrier: false,
                group_minimum_shipping_cost: null,

            }
            this.isLoading = false
        },

        fetchCarrierGroups() {
            console.log('fetching carrier groups');
            console.log(this.integrationId);
            if (!this.integrationId) {
                return;
            }

            let params = {
                limit: -1,
                integration_id: this.integrationId
            }
            this.$http
                .get('/api/carrier-groupings/', { params })
                .then(({ data }) => {
                    this.isLoading = false
                    this.groups = data.data.map(item => {
                        let idata = item.attributes
                        idata.id = item.id
                        console.log('group', idata)
                        return idata
                    })
                })
                .catch(err => {
                    console.log("[CARRIER_GROUP][FETCH] fail: ", err)
                    this.isLoading = false
                })
        },

        onNewGroup() {
            this.reset()
            this.form.is_rounding = "0"
            this.form.enabled = true
            // Set order to max order + 1
            if (this.groups && this.groups.length > 0) {
                const maxOrder = Math.max(...this.groups.map(g => Number(g.order) || 0));
                this.form.order = maxOrder + 1;
            } else {
                this.form.order = 1;
            }
            this.isNew = true
        },


        onDisplayLiveRateCarrierGroups() {
            let format = '';
            this.shareCarrierGroupBtnTxt = "Fetching...";
            this.$http
                .get('/api/carrier-groupings/liverate-groups-and-settings/' + this.integrationId)
                .then(({ data }) => {
                    format = data.format;
                    navigator.clipboard.writeText(format);
                    EventBus.$emit('show-success', 'Successfully copied to clipboard.');
                    this.shareCarrierGroupBtnTxt = "Share shipping options";
                })
                .catch(err => {
                    this.shareCarrierGroupBtnTxt = "Share shipping options";
                    EventBus.$emit('show-error', err);
                })
        },

        onSubmitCarrierGroup(e) {
            this.$v.form.$touch()
            e.preventDefault()
            if (this.valid) {
                if (!this.integrationId) {
                    EventBus.$emit('show-error', 'Please choose an integration first')
                    return
                }

                this.isLoading = true
                this.form.integration_id = this.integrationId
                // add or update carrier group here
                if (!this.form.id) {

                    if(this.$v.$pending) {
                        EventBus.$emit('show-error', 'Failed! Please try again.')
                        return
                    }
                    // add
                    this.form.slug = this.form.name
                    this.$http
                        .post('/api/carrier-groupings', this.form)
                        .then(({ data  }) => {
                            // show info
                            EventBus.$emit('show-success', 'Successfully saved new shipping option.');
                            this.form.id = data.data.id
                            this.groups.push(this.form)
                            this.reset()
                        })
                        .catch(err => {
                            EventBus.$emit('show-error', err);
                            this.isLoading = false
                        })

                } else {
                    this.$http
                        .patch('/api/carrier-groupings/' + this.form.id, this.form)
                        .then(res => {
                            // show info
                            EventBus.$emit('show-success', 'Successfully updated shipping option.');
                            this.isLoading = false
                            this.isNew = false
                        })
                        .catch(err => {
                            EventBus.$emit('show-error', err);
                            this.isLoading = false
                        })
                }


            } else {
                EventBus.$emit('show-error', 'Failed! Please try again.')
            }
        },

        onDelete() {
            this.$refs.modal.onShow(
                'Delete Confirmation',
                'Are you sure you want to delete this Shipping Option?',
                this.onDeleteConfirm
            );
        },

        onDeleteConfirm() {
            if (this.form.id) {
                this.isLoading = true
                this.$http
                    .post('/api/carrier-groupings/delete/' + this.form.id, { integration_id: this.integrationId, form: this.form })
                    .then(({ data }) => {
                        this.reset()
                        this.fetchCarrierGroups()
                        setTimeout(() => {
                            this.option = ''
                        }, 200)
                    })
            }
        },

        async onCreateDefault() {
            if (this.isLoading) {
                return
            }

            this.isLoading = true
            try {
                for (const form of this.defaultSettings) {
                    form.integration_id = this.integrationId
                    form.slug = form.name

                    await this.$http.post('/api/carrier-groupings', form)
                }

                EventBus.$emit('show-success', 'Successfully created default shipping options.')
                this.fetchCarrierGroups()
            } catch(err) {
                EventBus.$emit('show-error', err);
                this.isLoading = false
            }

        },
    },
}
</script>
